import { Dialog, DialogActions, DialogContent, DialogTitle, Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import InputSwitch from '../../../../components/inputs/yup/materialui/inputSwitch';
import { useForm } from 'react-hook-form';
import { CancelOutlined } from '@mui/icons-material';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { bloquearDesbloquearRol, obtenerEstadoRol } from '../services/serviceBloqueoRecaudacion';
import { RolResponse } from '../models/RolResponse';
import { useLoader } from '../../../../hooks/useLoader';
import { useToast } from '../../../../hooks/useToast';

interface bloqueoSistema {
    sistemaBloqueado: boolean;
}

interface IProps {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalBloqueoRecaudacion: React.FC<IProps> = ({ show, setShow }) => {

    const {
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        watch
    } = useForm<bloqueoSistema>({
        mode: 'onChange',
    });
    let isChecked = watch('sistemaBloqueado');

    const { showLoader, hideLoader } = useLoader();
    const { addToast } = useToast();

    const [originalState, setOriginalState] = useState(false); // TODO: CAMBIAR ESTE VALOR POR LO QUE TRAIGA EL SERVICIO


    const closeModal = () => setShow(false);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {},
    })

    const onSubmit = () => {

        if( isChecked === originalState ) {
            closeModal();
            return;
        }

        setModalConfirmacion({
            show: true,
            title: isChecked ? 'Deshabilitar recaudación' : 'Habilitar recaudación',
            message: isChecked ? '¿Está seguro que desea realizar la operación de deshabilitar?' : '¿Está seguro que desea realizar la operación de habilitar?',
            metodo: handleModificarState
        });

    };

    const handleModificarState = async () => {

        showLoader();
        const response = await bloquearDesbloquearRol({bloquear: isChecked});
        hideLoader();

        if( response.status !== 200 ){
            showToast("Bloqueo de recaudación", "Danger", `Ha ocurrido un error al intentar ${isChecked ? 'bloquear' : 'desbloquear'} la recaudación.`);
            return;
        }
        
        
        if( response.status === 200 ){
            const rol = response.data as RolResponse;
            const nuevoEstado = rol.bloqueado === "N" ? false : true
            setOriginalState(nuevoEstado);
            setValue('sistemaBloqueado', nuevoEstado);
            showToast("Bloqueo de recaudación", "Success", `Recaudacion ${nuevoEstado ? 'bloqueada' : 'desbloqueada'} correctamente.`);
        }
    };

    const getEstadoRol = useCallback(async (code: string) => {
        showLoader();
        const response = await obtenerEstadoRol(code);
        const rol = response.data as RolResponse;
        const isBloqueado = rol.bloqueado === "N" ? false : true;
        setOriginalState(isBloqueado);
        setValue('sistemaBloqueado', isBloqueado);
        hideLoader();
    }, [showLoader, hideLoader, setValue]);

    useEffect(() => {getEstadoRol('ADM')}, []);

    const showToast = (title: string, tipo: "Success" | "Danger" | "Warning" | "Info" | "Dark" | "Light", mensaje: string) => {
        addToast({
          mostrar: true,
          titulo: title,
          tipo,
          mensaje,
        });
    }

    return (
        <>
            <Dialog open={show} onClose={closeModal} maxWidth="xl" >
                <DialogTitle>Bloqueo del sistema para ingreso de recaudación</DialogTitle>
                  <DialogContent>
                    <p>Habilita la posiblidad de bloquear el ingreso o realizar los procesos de recaudación mientras el usuario Administrador Cartera lo estipule</p>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 4 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputSwitch
                                label={"Recaudación bloqueada"}
                                name="sistemaBloqueado"
                                control={control}
                                error={errors.sistemaBloqueado}
                            />
                        </form>
                    </Box>

                  </DialogContent>
                
                  <DialogActions>
                    <MButton
                      variant="contained"
                      color="error"
                      onClick={closeModal}
                      startIcon={<CancelOutlined />}
                    >
                      Cancelar
                    </MButton>
                    <MButton
                      variant="contained"
                      color="primary"
                      disabled={ isChecked === originalState ? true : false }
                      onClick={handleSubmit(onSubmit)}
                      startIcon={<CheckCircleTwoToneIcon />}
                    >
                      Aceptar
                    </MButton>
                  </DialogActions>
            </Dialog>

            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                title={modalConfirmacion.title}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
            />
        </>
    )
}

export default ModalBloqueoRecaudacion